import React, { useEffect, useRef } from "react";
import { BottomBar, Button, Container, Pagination, ResponsiveFields, Searchbox, Avatar } from "../../../../../Components";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useFetch from "../../../../../Hooks/useFetch";
import apis from "../../../../../Utils/apis";

function Users() {
	const NAVIGATE = useNavigate();
	const initial = { users: [], count: 0, pages: 0 };
	const [Query, setQuery] = useState({ search: "", page: 1 });
	const { response, loading } = useFetch(apis.getAllUsers, Query, initial);
	const listTopRef = useRef(null);
	const totalCount = Number(response.count) || 0;
	const totalPages = Math.max(1, Number(response.pages) || 1);
	const currentPage = Math.min(Math.max(Query.page, 1), totalPages);

	useEffect(() => {
		if (listTopRef.current) {
			listTopRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
		}
	}, [Query.page]);

	const viewEmployee = (user) => {
		NAVIGATE(`/app/travellers/${user.id}`);
	};

	return (
		<>
			<BottomBar>
				<div className="flex flex-col w-full gap-1.5">
					<div className="flex items-end justify-between gap-2">
						<h5 className="leading-tight">{totalCount} Users</h5>
						<div className="text-xs text-secondary whitespace-nowrap">Page {currentPage} of {totalPages}</div>
					</div>
					<Pagination showNumbers={false} active={currentPage} total={totalPages} onChange={(page) => setQuery({ ...Query, page })} />
				</div>
			</BottomBar>
			<div ref={listTopRef} className="mt-6 flex w-full">
				<Searchbox className="w-full sm:w-96" placeholder="Search Users" cmd="s" onChange={(search) => setQuery({ ...Query, search, page: 1 })} />
			</div>

			<Container variant="outlined" className="mt-4 mb-20 !p-2 sm:!p-4">
				{loading ? (
					<div className="p-4 text-sm text-secondary">Loading...</div>
				) : (
					<ResponsiveFields
						variant="cards"
						columnsClassName="sm:grid-cols-2 lg:grid-cols-3"
						items={response.users || []}
						getKey={(u, i) => `${u?.id || ""}-${i}`}
						columns={[
							{ key: "photo", label: "Photo", render: (u) => <Avatar photo={u.photo} className="w-10 h-10" /> },
							{ key: "name", label: "Name", valueClassName: "font-bold break-words", render: (u) => `${u.fName} ${u.lName}` },
							{ key: "email", label: "Email", valueClassName: "break-words", render: (u) => u.email || "-" },
							{ key: "team", label: "Team", render: (u) => u.team?.name || "-" },
							{ key: "office", label: "Office", render: (u) => u.office?.name || "-" },
							{
								key: "action",
								label: "Action",
								render: (u) => (
									<Button onClick={() => viewEmployee(u)} variant="outlined" className="btn-xs w-full sm:w-auto">
										Open
									</Button>
								),
							},
						]}
					/>
				)}
			</Container>
		</>
	);
}

export default Users;
